// extracted by mini-css-extract-plugin
module.exports = {"container":"Issue_container_2FFKB","main":"Issue_main_3acCH","aside":"Issue_aside_Mz3rS","actions":"Issue_actions_2Aezm"};